import script from "./xianqing1.vue?vue&type=script&setup=true&lang=js"
export * from "./xianqing1.vue?vue&type=script&setup=true&lang=js"

import "./xianqing1.vue?vue&type=style&index=0&id=6104ce4e&lang=less&scoped=true"
script.__scopeId = "data-v-6104ce4e"

export default script